import "./FooterStyles.css";

import React from 'react';
import { Link } from "react-router-dom";

import { FaFacebook, FaHome, FaLinkedin, FaMailBulk, FaPhone, FaGithub } from "react-icons/fa";
const Footer = () => {
    return (
        <div className="footer">
            <div className="footer-container">
                <div className="left">
                    <div className="location">
                        <FaHome size={20} style={{ color: "#fff", marginRight: "1rem" }} />
                        <div>
                            <p>Samastipur</p>
                            <p>Bihar-848113</p>
                            <p>India</p>
                        </div>
                    </div>
                    <div className="phone">
                        <h4> <FaPhone size={20} style={{ color: "#fff", marginRight: "1rem" }} />
                            +91-8825248677</h4>
                    </div>
                    <div className="email">
                        <h4> <FaMailBulk size={20} style={{ color: "#fff", marginRight: "1rem" }} />
                            ranjanrishav87@gmail.com</h4>
                    </div>
                </div>
                <div className="right">
                    <h4>About the company</h4>
                    <p>Hey myself Rishav Ranjan.This is my portfolio
                        website where i have listed my projects,
                        skills and experiences.I enjoy learning and exploring
                        new skills and oppurtunities.Below is the link to my facebook,Github and linkedin profiles.
                    </p>
                    <div className="social">
                        <Link to="https://www.facebook.com/profile.php?id=100008454360097"><FaFacebook size={30} style={{ color: "#fff", marginRight: "1rem" }} /></Link>
                        <Link to="https://github.com/RishavRanjan786"><FaGithub size={30} style={{ color: "#fff", marginRight: "1rem" }} /></Link>
                        <Link to="https://www.linkedin.com/in/rishav-ranjan-96b706247/"><FaLinkedin size={30} style={{ color: "#fff", marginRight: "1rem" }} /></Link>
                    </div>
                </div>

            </div>
        </div >
    )
};

export default Footer
